import { RadioGroup } from "../../ui/RadioGroup";
import {CheckboxGroup } from "../../ui/Checkbox";
import { SubHead } from "../../ui/SubHead";
import { Textarea } from "../../ui/Textarea";
import { Input } from "../../ui/Input";
import { Select } from "../../ui/Select";
import { yesNoOption } from "../../options/options";
import {SearchableSelect} from "../../ui/SearchableSelectReact";
export const RiskAssesContinueForm = ({
  companyName,
  formData,
  handleChange,
  isReadOnly,
  sendMail,
  handleSubmit,
  countries,
  handleCountryChange,
  showSections,
  isReport
}) => {
  return (
    <div className="transaction-form form_information">
      <h2>Risk Assessment Continue</h2>
      <form onSubmit={handleSubmit}>
        {/* if question 2 is continued from risk Assessment */}
        {showSections.includes("pepOwner") && (
          <>
            <RadioGroup
              label={`Is the client/counterparty or beneficial owner a UK PEP?`}
              name="UKpep"
              value={formData.UKpep}
              disabled={isReadOnly}
              onChange={handleChange}
              options={yesNoOption}
              isReport={isReport}
              required={true}
            />
            {(formData.UKpep === "No") && (
              <>
                <SearchableSelect
                  label="What Jurisdiction is this PEP in?"
                  name="PepJurisdiction"
                  value={formData.PepJurisdiction}
                  options={countries.map((country) => ({
                    value: country,
                    display_value: country,
                  }))}
                  onChange={handleChange}
                  disabled={isReadOnly}
                  required={true}
                  isReport={isReport}
                />
              </>

            )}
            {/* <Select
              label="What Jurisdiction is this PEP in? *"
              name="PepJurisdiction"
              value={formData.PepJurisdiction}
              options={countries.map((country) => ({
                value: country,
                display_value: country,
              }))}
              onChange={handleChange }
              disabled={isReadOnly}
              required={true}
            /> */}
            <Select
                  label="Type of PEP:"
                  name="PepType"
                  value={formData.PepType}
                  onChange={handleChange}
                  required={true}
                  disabled={isReadOnly}
                  isReport={isReport}
                  options={[
                    { value: "Government Official", display_value: "Government Official" },
                    { value: "Member of Parliament", display_value: "Member of Parliament" },
                    { value: "Local MP", display_value: "Local MP" },
                    { value: "Ultra-High net worth individual", display_value: "Ultra-High net worth individual" },
                    { value: " Close associate/ spouse or family member of a UK PEP", display_value: " Close associate/ spouse or family member of a UK PEP" },
                    { value: "Member of the Royal Family", display_value: "Member of the Royal Family" },
                    { value: "Managing official of a Government Entity", display_value: "Managing official of a Government Entity" },
                    { value: "Other", display_value: "Other" }
                  ]}
                />
            {/* {(formData.UKpep === "Yes") && (
              <>

                
              </>
            )} */}
            {(formData.PepType === "Other") && (
              <Input
                label="Describe PEP:"
                type="text"
                name="PepDescription"
                value={formData.PepDescription}
                onChange={handleChange}
                disabled={isReadOnly}
                isReport={isReport}
                required={true}
              />
            )}
            <div style={{ width: "100%", display: "inline-block", height: "3px", borderRadius: "5px", backgroundColor: "#07b1b0" }}></div>

          </>
        )}
        {/* if question 3 is continued from risk assement */}
        {showSections.includes("sanctionedPerson") && (
          <>
            <SubHead text="User has indicated a sanctioned person" isReport={isReport} />
            <Input
              label="Aliases (if any):"
              type="text"
              name="Aliases"
              value={formData.Aliases}
              disabled={isReadOnly}
              onChange={handleChange}
              isReport={isReport}
              required={true}
            />
            <Input
              label="What year was the individual Sanctioned in?"
              type="text"
              name="SanctionedYear"
              disabled={isReadOnly}
              value={formData.SanctionedYear}
              onChange={handleChange}
              isReport={isReport}
              required={true}
            />
            <Select
              label="What is the reason for the sanction?"
              name="sanctionReason"
              value={formData.sanctionReason}
              onChange={handleChange}
              required={true}
              disabled={isReadOnly}
              isReport={isReport}
              
              options={[
                { value: "Terrorism financing", display_value: "Terrorism financing" },
                { value: "Money laundering", display_value: "Money laundering " },
                { value: "Human rights violations ", display_value: "Human rights violations" },
                { value: "Corruption/ bribery ", display_value: "Corruption/ bribery" },
                { value: "Political exposure ", display_value: " Political exposure" },
                { value: "Other", display_value: "Other" }
              ]}
            />
            {(formData.sanctionReason === "Other") && (
              <Input
                label="Describe reason for sanction:"
                type="text"
                name="ReasonDescription"
                value={formData.ReasonDescription}
                disabled={isReadOnly}
                onChange={handleChange}
                isReport={isReport}
                required={true}
              />
            )}
            <RadioGroup
              label={`Is this individual/entity sanctioned in the UK?`}
              name="UKsanctioned"
              value={formData.UKsanctioned}
              disabled={isReadOnly}
              onChange={handleChange}
              options={yesNoOption}
              isReport={isReport}
              required={true}
            />
            <RadioGroup
              label={`Are there any mitigating factors that suggest the match is incorrect or low risk? *`}
              name="mitigatingFactors"
              value={formData.mitigatingFactors}
              disabled={isReadOnly}
              onChange={handleChange}
              options={yesNoOption}
              isReport={isReport}
              required={true}
            />
            {(formData.mitigatingFactors === "Yes") && (
              <>
                <Input
                  label="Provide further details: *"
                  type="text"
                  name="FactorDetails"
                  disabled={isReadOnly}
                  value={formData.FactorDetails}
                  onChange={handleChange}
                  isReport={isReport}
                  required={true}
                />
                {!isReport && <button style={{
                  marginTop: "10px",
                  padding: "8px",
                  border: "none",
                  background: "#07b1b0",
                  color: "white",
                  borderRadius: "4px",
                  cursor: "pointer",
                  float: "left"
                }}
                  disabled={isReadOnly || !formData.FactorDetails?.trim()}
                  onClick={() => sendMail("MLNO", "Provide further details: for mitigating factors", formData.FactorDetails)}
                >Submit to MLNO for Review</button>}
              </>
            )}
            <div style={{ width: "100%", display: "inline-block", height: "3px", borderRadius: "5px", backgroundColor: "#07b1b0" }}></div>
          </>
        )}


        {/* Question 4 is continued from risk Assessment */}
        {showSections.includes("understandClientBussiness") && (
          <>
            <Select
              label="Which aspects of the business is unclear? 				"
              name="businessAspects"
              value={formData.businessAspects}
              onChange={handleChange}
              required={true}
              disabled={isReadOnly}
              isReport={isReport}
              options={[
                { value: "Nature of Services", display_value: "Nature of Services" },
                { value: "Structure", display_value: "Structure" },
                { value: "Revenue model", display_value: "Revenue model" },
                { value: "Economic objectives ", display_value: "Economic objectives " }
              ]}
            />
            <RadioGroup
              label={`Has the client’s business been described in vague or generic terms? `}
              name="genericTerms"
              value={formData.genericTerms}
              disabled={isReadOnly}
              onChange={handleChange}
              options={yesNoOption}
              isReport={isReport}
            />
            {(formData.genericTerms === "Yes") && (
              <Textarea
                label="Describe Your understanding of the business:				"
                type="text"
                name="businessUnderstanding"
                disabled={isReadOnly}
                value={formData.businessUnderstanding}
                onChange={handleChange}
                isReport={isReport}
              />
            )}
            <RadioGroup
              label={`Have any public records or online resources helped clarify the business? `}
              name="clarifyResources"
              value={formData.clarifyResources}
              disabled={isReadOnly}
              onChange={handleChange}
              options={yesNoOption}
              isReport={isReport}
            />
            {(formData.clarifyResources === "Yes") && (
              <Textarea
                label="Document these resources:"
                type="text"
                disabled={isReadOnly}
                name="resources"
                value={formData.resources}
                onChange={handleChange}
                isReport={isReport}
              />
            )}
            {(formData.clarifyResources === "No") && (
              <Select
                label="Indicate the reason why:			"
                name="reason"
                value={formData.reason}
                onChange={handleChange}
                required={true}
                disabled={isReadOnly}
                isReport={isReport}
                options={[
                  { value: "No/minimal public records available", display_value: "No/minimal public records available;" },
                  { value: "Public records are behind a paywall or require translation ", display_value: "Public records are behind a paywall or require translation " },
                  { value: "Public records are vague and/or unrelated to the business ", display_value: "Public records are vague and/or unrelated to the business " },
                  { value: "Other", display_value: "Other" }
                ]}
              />
            )}
            {(formData.reason === "Other") && (
              <Input
                label="Describe reason"
                type="text"
                disabled={isReadOnly}
                name="ReasonDescribe"
                value={formData.ReasonDescribe}
                onChange={handleChange}
                isReport={isReport}
              />
            )}
            <Textarea
              label="What specific information or documents do you feel would help you better understand the business? 								"
              type="text"
              name="specificInformation"
              value={formData.specificInformation}
              onChange={handleChange}
              disabled={isReadOnly}
              isReport={isReport}
            />
            {!isReport && <div style={{ width: "100%", display: "inline-block" }}>
              <button style={{
                marginTop: "10px",
                padding: "8px",
                border: "none",
                background: "#07b1b0",
                color: "white",
                borderRadius: "4px",
                cursor: "pointer",
                float: "left"
              }}
                disabled={isReadOnly || !formData.specificInformation?.trim()}
                onClick={() => sendMail("MLNO", "What specific information or documents do you feel would help you better understand the business? ", formData.specificInformation)}
              >Submit to MLNO for Review</button>
            </div>}
            {!isReport && <div style={{ width: "100%", display: "inline-block", height: "3px", borderRadius: "5px", backgroundColor: "#07b1b0" }}></div>}
          </>
        )}

        {/* if question 5 from risk assement is continued */}
        {showSections.includes("particularTransaction") && (
          <>
            <RadioGroup
              label={`Have you taken steps to understand the intended outcome of the transaction from the client’s perspective?`}
              name="intendedOutcome"
              value={formData.intendedOutcome}
              disabled={isReadOnly}
              onChange={handleChange}
              options={yesNoOption}
              isReport={isReport}
            />
            {(formData.intendedOutcome === "Yes") && (
              <Textarea
                label="Detail steps you have taken: 			"
                type="text"
                name="stepsDetail"
                value={formData.stepsDetail}
                disabled={isReadOnly}
                onChange={handleChange}
                isReport={isReport}
              />
            )}
            <RadioGroup
              label={`Is the transaction consistent with the client’s stated business model or historical activity`}
              name="statedBusinessModel"
              value={formData.statedBusinessModel}
              disabled={isReadOnly}
              onChange={handleChange}
              options={yesNoOption}
              isReport={isReport}
            />
            <Textarea
              label="Provide any additional details "
              type="text"
              name="additionalDetails"
              disabled={isReadOnly}
              value={formData.additionalDetails}
              onChange={handleChange}
              isReport={isReport}
            />
            {!isReport && <div style={{ width: "100%", display: "inline-block" }}>
              <button style={{
                marginTop: "10px",
                padding: "8px",
                border: "none",
                background: "#07b1b0",
                color: "white",
                borderRadius: "4px",
                cursor: "pointer",
                float: "left"
              }}
                disabled={isReadOnly || !formData.additionalDetails?.trim()}
                onClick={() => sendMail("MLNO", "Provide any additional details for cash intensive bussiness", formData.additionalDetails)}
              >Submit to MLNO for Review</button>
            </div>}
            {!isReport && <div style={{ width: "100%", display: "inline-block", height: "3px", borderRadius: "5px", backgroundColor: "#07b1b0" }}></div>}
          </>
        )}
        {/* display if question 8 is continued from risk assement */}
        {showSections.includes("sectorFromDropdown") && (
          <>
            <RadioGroup
              label={`Is this entity a well-known organisation in the sector?`}
              name="knownCovenant"
              value={formData.knownCovenant}
              disabled={isReadOnly}
              onChange={handleChange}
              options={[...yesNoOption, { value: "Unknown", display_value: "Unknown" }]}
              isReport={isReport}
              required={true}
            />
            <Input
              label="How long has this entity been operating in this sector? (in years)"
              type="number"
              name="operatingYear"
              value={formData.operatingYear}
              onChange={handleChange}
              step={1}
              min={0}
              isReport={isReport}
            />
            <div style={{ width: "100%", display: "inline-block", height: "3px", borderRadius: "5px", backgroundColor: "#07b1b0" }}></div>
          </>
        )}
        {/* if question 10 is continued from risk assement */}
        {showSections.includes("pepEvasive") && (
          <>

            <Textarea
              label="What specific information or documents has the client/counterparty been unwilling to provide?"
              type="text"
              name="unwillingInformation"
              value={formData.unwillingInformation}
              onChange={handleChange}
              disabled={isReadOnly}
              isReport={isReport}
              required={true}
            />
            <Input
              label="Have they given a reason for this delay? "
              type="text"
              name="DelayReason"
              disabled={isReadOnly}
              value={formData.DelayReason}
              onChange={handleChange}
              isReport={isReport}
              required={true}
            />
            <Textarea
              label="How many requests have you made for the missing information/documents? (Include dates or frequency of followup) "
              type="text"
              disabled={isReadOnly}
              name="RequestMissingInfo"
              value={formData.RequestMissingInfo}
              onChange={handleChange}
              isReport={isReport}
              required={true}
            />
            <div style={{ width: "100%", display: "inline-block", height: "3px", borderRadius: "5px", backgroundColor: "#07b1b0" }}></div>
          </>
        )}
        {/* if question 11 is continued from risk assement */}
        {showSections.includes("transactionCompletedWithUndueSpeed") && (
          <>
            <Input
              label="What specific timeframe has the client/counterparty requested for completion? "
              type="text"
              name="timeframe"
              disabled={isReadOnly}
              value={formData.timeframe}
              onChange={handleChange}
              isReport={isReport}
              required={true}
            />
            <Input
              label="Has the client/counterparty provided a reason for the urgency? "
              type="text"
              name="urgencyReason"
              value={formData.urgencyReason}
              disabled={isReadOnly}
              onChange={handleChange}
              isReport={isReport}
              required={true}
            />
            <Textarea
              label="Is there any indication that the urgency may be linked to a significant event? (e.g., year-end, regulatory changes, etc.) "
              type="text"
              disabled={isReadOnly}
              name="urgencyEvent"
              value={formData.urgencyEvent}
              onChange={handleChange}
              isReport={isReport}
              required={true}
            />
            {!isReport && <div style={{ width: "100%", display: "inline-block" }}>
              <button style={{
                marginTop: "10px",
                padding: "8px",
                border: "none",
                background: "#07b1b0",
                color: "white",
                borderRadius: "4px",
                cursor: "pointer",
                float: "left"
              }}
                disabled={isReadOnly || !formData.urgencyEvent?.trim()}
                onClick={() => sendMail("MLNO", "Is there any indication that the urgency may be linked to a significant event? (e.g., year-end, regulatory changes, etc.)", formData.urgencyEvent)}
              >Submit to MLNO for Review</button>
            </div>}
            {!isReport && <div style={{ width: "100%", display: "inline-block", height: "3px", borderRadius: "5px", backgroundColor: "#07b1b0" }}></div>}
          </>
        )}



        {/* if question 13 & 14 is continued from risk assement */}
        {(showSections.includes("adversePublicity") || showSections.includes("adverseInformation")) && (
          <>
            <Textarea
              label="What specific adverse information did your searches reveal? (Please Summarise) "
              type="text"
              disabled={isReadOnly}
              name="adverseInformation"
              value={formData.adverseInformation}
              onChange={handleChange}
              isReport={isReport}
              required={true}
            />
            {/* <RadioGroup
              label={`What is the source of the coverage? *`}
              name="coverageSource"
              value={formData.coverageSource}
              disabled={isReadOnly}
              onChange={handleChange}
              options={[
                { value: "Media", display_value: "Media" },
                { value: "Online Searches", display_value: "Online Searches" },
                { value: "Word of Mouth", display_value: "Word of Mouth" },
                { value: "Electronic Screening Software ", display_value: "Electronic Screening Software" },
                { value: "Foreign Press", display_value: "Foreign Press" },
                { value: "Official Publication", display_value: "Official Publication (eg., FATF, Transparency International, etc.)" },
                { value: "Other", display_value: "Other" }
              ]}
            required={true}
            /> 
            */}
            <CheckboxGroup
            isReport={isReport}
  label="What is the source of the coverage? "
  name="coverageSource"
  value={formData.coverageSource || []}  // Array of selected options
  disabled={isReadOnly}  // Disable checkboxes if needed
  onChange={handleChange}  // Function to update the selected options
  options={[
    { value: "Media", display_value: "Media" },
    { value: "Online Searches", display_value: "Online Searches" },
    { value: "Word of Mouth", display_value: "Word of Mouth" },
    { value: "Electronic Screening Software", display_value: "Electronic Screening Software" },
    { value: "Foreign Press", display_value: "Foreign Press" },
    { value: "Official Publication", display_value: "Official Publication (eg., FATF, Transparency International, etc.)" },
    { value: "Other", display_value: "Other" }
  ]}
  required={true}
/>

{(formData.coverageSource && formData.coverageSource.includes("Other")) && (
  <Input
  isReport={isReport}
    label="Describe source of coverage: "
    type="text"
    disabled={isReadOnly}
    name="coverageDetail"
    value={formData.coverageDetail}
    onChange={handleChange}
    required={true}
  />
)}

            <RadioGroup
              label={`Has the client/counterparty directly addressed the adverse publicity with you during the course of your engagement? `}
              name="adversePublicity"
              value={formData.adversePublicity}
              disabled={isReadOnly}
              onChange={handleChange}
              options={yesNoOption}
              isReport={isReport}
              required={true}
            />
            <RadioGroup
              label={`Do you believe these findings warrant escalation or further internal investigation? `}
              name="findingsInvestigation"
              value={formData.findingsInvestigation}
              disabled={isReadOnly}
              onChange={handleChange}
              options={[...yesNoOption, { value: "Unknown", display_value: "Unknown" }]}
              isReport={isReport}
              required={true}
            />

            {!isReport && <div style={{ width: "100%", display: "inline-block" }}>
              <button style={{
                marginTop: "10px",
                padding: "8px",
                border: "none",
                background: "#07b1b0",
                color: "white",
                borderRadius: "4px",
                cursor: "pointer",
                float: "left"
              }}
                disabled={isReadOnly || !formData.findingsInvestigation?.trim()}
                onClick={() => sendMail("MLNO", "`Do you believe these findings warrant escalation or further internal investigation?", formData.findingsInvestigation)}
              >Submit to MLNO for Review</button>
            </div>}
            {!isReport && <div style={{ width: "100%", display: "inline-block", height: "3px", borderRadius: "5px", backgroundColor: "#07b1b0" }}></div>}
          </>
        )}

        {/* if question 15 is continued from risk assement */}
        {showSections.includes("criminalProceedings") && (
          <>
            <Input
              label="What was the nature of the offense? "
              type="text"
              disabled={isReadOnly}
              name="offenseNature"
              value={formData.offenseNature}
              onChange={handleChange}
              isReport={isReport}
            required={true}
            />


            <SearchableSelect
              label="In which jurisdiction did the proceedings take place: "
              name="OffenceReason"
              value={formData.OffenceReason}
              options={countries.map((country) => ({
                value: country,
                display_value: country,
              }))}
              onChange={handleChange}
              disabled={isReadOnly}
              required
              isReport={isReport}
            />



{/* 
            <Select
              label="In which jurisdiction did the proceedings take place: *"
              name="OffenceReason"
              value={formData.OffenceReason}
              onChange={handleChange}
              required={true}
              disabled={isReadOnly}
              options={[
                { value: "UK", display_value: "UK" },
                { value: "US", display_value: "US" },
                { value: "Europe", display_value: "Europe" },
                { value: "India", display_value: "India" },
              ]}
            /> */}
            <RadioGroup
              label={`Was this a “white-collar” offence? `}
              name="whiteCollarOffence"
              value={formData.whiteCollarOffence}
              disabled={isReadOnly}
              onChange={handleChange}
              options={[...yesNoOption, { value: "Unknown", display_value: "Unknown" }]}
              isReport={isReport}
            required={true}
            />
            <RadioGroup
              label={`Did the client/counterparty disclose the proceedings voluntarily? `}
              name="proceedingsVoluntarily"
              value={formData.proceedingsVoluntarily}
              disabled={isReadOnly}
              onChange={handleChange}
              options={[...yesNoOption, { value: "Unknown", display_value: "Unknown" }]}
              isReport={isReport}
            required={true}
            />
            <RadioGroup
              label={`Do the proceedings indicate an elevated financial crime risk or potential reputational concerns relevant to this transaction? `}
              name="reputationalConcerns"
              value={formData.reputationalConcerns}
              disabled={isReadOnly}
              onChange={handleChange}
              options={[...yesNoOption, { value: "Unknown", display_value: "Unknown" }]}
              isReport={isReport}
            required={true}
            />
            {!isReport && <div style={{ width: "100%", display: "inline-block" }}>
              <button style={{
                marginTop: "10px",
                padding: "8px",
                border: "none",
                background: "#07b1b0",
                color: "white",
                borderRadius: "4px",
                cursor: "pointer",
                float: "left"
              }}
                disabled={isReadOnly || !formData.reputationalConcerns?.trim()}
                onClick={() => sendMail("MLNO", "Do the proceedings indicate an elevated financial crime risk or potential reputational concerns relevant to this transaction?", formData.reputationalConcerns)}
              >Submit to MLNO for Review</button>
            </div>}
            {!isReport && <div style={{ width: "100%", display: "inline-block", height: "3px", borderRadius: "5px", backgroundColor: "#07b1b0" }}></div>}
          </>
        )}

        {/* display for question 16 */}
        {showSections.includes("taxInvasionIndication") && (
          <>
            <RadioGroup
              label={`Has the client/ counterparty previously been subject to allegations involving tax avoidance or evasion? `}
              name="subjectAllegations"
              value={formData.subjectAllegations}
              disabled={isReadOnly}
              onChange={handleChange}
              options={yesNoOption}
              isReport={isReport}
            required={true}
            />
            <Textarea
              label="Please provide further details: "
              type="text"
              disabled={isReadOnly}
              name="AllegationsDetails"
              value={formData.AllegationsDetails}
              onChange={handleChange}
              isReport={isReport}
            required={true}
            />
            {!isReport && <div style={{ width: "100%", display: "inline-block" }}>
              <button style={{
                marginTop: "10px",
                padding: "8px",
                border: "none",
                background: "#07b1b0",
                color: "white",
                borderRadius: "4px",
                cursor: "pointer",
                float: "left"
              }}
                disabled={isReadOnly || !formData.AllegationsDetails?.trim()}
                onClick={() => sendMail("MLNO", "Please provide further details: for AllegationsDetails", formData.AllegationsDetails)}
              >Submit to MLNO for Review</button>
            </div>}

          </>
        )}

      </form>

    </div>
  )
}